import React from 'react'

// components
import { ProfilePersonalInfo } from './profileBar/ProfilePersonalInfo.component'
import { ProfileAbout } from './profileBar/ProfileAbout.component'
import { SocialLinks } from './profileBar/SocialLinks.component'
import { TagsSection } from './profileBar/TagsSection.component'
import { IUser } from 'interfaces/user'
import { useSortTags } from '@/shared/hooks/getTags'
import { conditionalClass, cssClass } from 'shared/utils/styles'
import { useProfilePage } from '../../../shared/hooks/profilePage'

// styles
import {
  profileBarContainer,
  sectionDivider,
  contentProfileContainer,
  contentProfileContainerExpanded,
  collapsiveLabelContainer,
  collapsiveLabel,
  collapsiveIcon,
  collapsiveIconOpen,
  containerForOtherProfiles,
} from 'styles/v2/pages/profile'
import {
  COLLAB_TYPES,
  CONTENT_TYPE_TAG,
  CREATOR_TYPES,
} from '@/shared/consts/tags'
import { UserContext } from 'context'
import { ProfileTitleEdit } from './profileBar/ProfileTitleEdit'

export const ProfileBar: React.FC<IUser> = () => {
  const { profile, ownProfile } = useProfilePage()
  const { updateUser } = React.useContext(UserContext)
  const [contentTypeTags] = useSortTags(CONTENT_TYPE_TAG)
  const [collabTypeTags] = useSortTags(COLLAB_TYPES)

  const [showMore, setShowMore] = React.useState(false)

  const saveCreatorType = async (tags: string[]) => {
    await saveTags({
      creatorType: tags,
    })
  }

  const saveCollabInterest = async (tags: string[]) => {
    await saveTags({
      collabInterest: tags,
    })
  }

  const saveContentType = async (tags: string[]) => {
    await saveTags({
      contentType: tags,
    })
  }

  const saveTags = async (user: Partial<IUser>) => {
    await updateUser(user)
  }

  if (!profile) return null
  return (
    <div className={cssClass([profileBarContainer, ownProfile ? '' : 'pb-20'])}>
      <ProfilePersonalInfo />

      <div
        className={cssClass([
          conditionalClass(
            showMore,
            contentProfileContainerExpanded,
            contentProfileContainer
          ),
          conditionalClass(ownProfile, '', containerForOtherProfiles),
          'full-w',
        ])}
      >
        <div
          className={cssClass([
            collapsiveLabelContainer,
            ownProfile ? '' : 'mt-18',
          ])}
          onClick={() => setShowMore(!showMore)}
        >
          <p className={collapsiveLabel}>MORE DETAILS</p>

          <div
            className={conditionalClass(
              showMore,
              collapsiveIconOpen,
              collapsiveIcon
            )}
          ></div>
        </div>

        {ownProfile && <ProfileTitleEdit />}

        <ProfileAbout />

        <div className={sectionDivider}></div>

        <SocialLinks />

        <div className={sectionDivider}></div>

        <TagsSection
          onSave={saveCreatorType}
          title="Creator Types"
          tags={profile?.creatorType}
          options={CREATOR_TYPES}
          editable={ownProfile}
        />

        <div className={sectionDivider}></div>

        <TagsSection
          title="Content Types"
          onSave={saveContentType}
          options={contentTypeTags}
          tags={profile?.contentType}
          editable={ownProfile}
        />

        <div className={sectionDivider}></div>

        <TagsSection
          title="Collaboration Types"
          onSave={saveCollabInterest}
          options={collabTypeTags}
          editable={ownProfile}
          tags={profile?.collabInterest}
        />
      </div>
    </div>
  )
}
